import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  height: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  background: #ffffff;
  height: 52px;

  // modify style of Antd Icon
  & .anticon {
    font-size: 12px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: start;
  }
`;

export const HeaderTitleName = styled.span`
  color: rgba(0, 0, 0, 0.88);
  letter-spacing: -0.02em;
  font-weight: 500;
  font-size: 16px;
`;
